import ProfileForm from "./ProfileForm";
import GotQuestion from "@/components/GotQuestion";

export default function MyProfile() {
  return (
    <div className="flex flex-col justify-center py-10">
      <div className="max-w-3xl mx-auto bg-brand-neutral-900 rounded-2xl pb-6">
        <ProfileForm />
        <GotQuestion />
      </div>
    </div>
  );
}
